import React, {useState} from "react";
import {View, StyleSheet, TouchableOpacity} from "react-native";
import PtText from "../core/pt-text/pt-text";
import {styleVars} from "../../app-style-vars";
import PtIcon from "../core/pt-icon/pt-icon";
import {getTranslation} from "../../helpers/getTranslation";
import PtTicketStatusIndicator from "./pt-ticket-status-indicator";


export default function PtTicketSingle(props:any) {

  const ticketTypeLabel = props.ticketTypeLabel || getTranslation('tickets.tracking.ticket.type.label') || 'Type';
  const ticketReasonLabel = props.ticketReasonLabel || getTranslation('tickets.tracking.ticket.reason.label') || 'Reason';
  const ticketRequestLabel = props.ticketRequestLabel || getTranslation('tickets.tracking.ticket.request.label') || 'Request';

  const ticket = props.ticket;

  const [showDetails, setShowDetails] = useState(false);

  const toggleDetails = () => {
    setShowDetails(!showDetails);
  }


  return (
    <View style={[styles.ticketContainer]}>
      <TouchableOpacity onPress={() => toggleDetails()}>
        <View style={[styles.ticketHeaderContainer]}>
{/*
          left the whole mechanism here if we decide to add sub levels to ticket presentation
          <View style={[styles.openIndicator]}>
            <PtIcon iconName={showDetails ? 'less-minimize' : 'add'} iconSize={24} iconColor={styleVars.boschDarkBlue}/>
          </View>
*/}
          <View style={[styles.headerDataContainer]}>
            <View style={[styles.headerDataRowFirst]}>
              <View style={[styles.headerDataColumn, styles.headerDataColumnLeftFirst]}>
                <View style={{flexDirection: 'row', flexWrap: 'nowrap', justifyContent: 'space-between', alignItems: 'center'}}>
                  <PtIcon iconName={`ticket`} iconSize={36} iconColor={styleVars.boschDarkBlue}/>
                  <PtText>{ticket.ticketId}</PtText>
                </View>
              </View>
              <View style={[styles.headerDataColumn, styles.headerDataColumnMiddle]}>
                <PtText style={[styles.headerDataValueText]}>{ticket.creationDate}</PtText>
              </View>
              <View style={[styles.headerDataColumn, styles.headerDataColumnRight]}>
                <PtTicketStatusIndicator statusCode={ticket.ticketStatusCode} statusText={ticket.ticketStatus}/>
              </View>
            </View>
            <View style={[styles.headerDataRowSecond]}>
              <View style={[styles.headerDataColumn, styles.headerDataColumnLeftSecond]}>
                <PtText style={[styles.headerDataValueText]}>{ticketTypeLabel}: {ticket.ticketType}</PtText>
              </View>
              <View style={[styles.headerDataColumn, styles.headerDataColumnMiddle]}>
                <PtText style={[styles.headerDataValueText]}>{ticketReasonLabel}: {ticket.ticketReason || '-'}</PtText>
                <PtText style={[styles.headerDataValueText]}>{ticketRequestLabel}: {ticket.ticketRequest || '-'}</PtText>
              </View>
            </View>
          </View>
        </View>
      </TouchableOpacity>
      {showDetails ?
        <View style={[styles.ticketDetailsContainer]}>
        </View>
        : null
      }
    </View>
  )
}

const styles = StyleSheet.create({
  ticketContainer: {
    paddingVertical: styleVars.rem(.5),
    borderBottomWidth: 1,
    borderBottomColor: styleVars.boschLightGray,
    zIndex: 1,
  },
  ticketHeaderContainer: {
    /*paddingLeft: styleVars.rem(2.5), needed if we add sub levels, padding to fit +/- signs */
  },
  openIndicator: {
    position: 'absolute',
    top: styleVars.rem(.5),
    left: styleVars.rem(.5),
    width: styleVars.rem(1.5),
    height: styleVars.rem(1.5),
  },
  headerDataRowFirst: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerDataRowSecond: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  headerDataColumn: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    overflow: 'hidden',
    marginHorizontal: styleVars.rem(.5),
  },
  headerDataColumnLeftFirst: {
    justifyContent: 'flex-start',
    maxWidth: '30%',
    minWidth: '30%',
  },
  headerDataColumnMiddle: {
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  headerDataColumnRight: {
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
  },
  headerDataColumnLeftSecond: {
    maxWidth: '30%',
    minWidth: '30%',
  },
  headerDataValueText: {
    fontSize: styleVars.rem(.875),
    width: '100%',
  },
  invoiceNumberText: {
    color: styleVars.boschDarkBlue
  },
  ticketDetailsContainer: {
    marginVertical: styleVars.rem(0), /* change this to 0.5 if we add sub levels */
    paddingLeft: styleVars.rem(2.5),
    paddingRight: styleVars.rem(.5)
  },
  ticketDetailsContentContainer: {
    backgroundColor: styleVars.boschLightGrayW75,
    paddingHorizontal: styleVars.rem(1)
  },
  detailContainer: {
    paddingVertical: styleVars.rem(.5),
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  detailLabelContainer: {
    maxWidth: '50%',
    justifyContent: 'flex-start',
  },
  detailValueContainer: {
    maxWidth: '50%',
    justifyContent: 'center',
    alignItems: 'flex-end'
  },
  detailLabel: {
    textAlign: 'left',
    fontWeight: '600'
  },
  detailValue: {
    textAlign: 'right'
  }
})